import React from "react";
import type { Filters, Manifest } from "../types.js";

interface Props {
  manifest: Manifest;
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  resultCount: number;
}

export function Header({ manifest, filters, setFilters, resultCount }: Props) {
  return (
    <header className="header">
      <div className="brand">
        <img src="/moldex-logo.png" alt="Moldex" className="brand-logo" />
        <div className="brand-text">
          <span className="brand-title">Asset Library</span>
          <span className="count">
            {resultCount.toLocaleString()} of {manifest.counts.totalAssets.toLocaleString()} assets
          </span>
        </div>
      </div>
      <input
        type="search"
        placeholder="Search by name, SKU, tag…"
        value={filters.search}
        onChange={(e) => setFilters((f) => ({ ...f, search: e.target.value }))}
        className="search"
      />
    </header>
  );
}
